export const APP = {
  name: "Pimmy",
  lang: navigator.language.substring(0,2)
};
